<div class="container-toaster" *ngIf="{ toasters: toasters$ | async } as content">
  <ng-container *ngFor="let toaster of content.toasters">
    <toaster-item [toaster]="toaster"></toaster-item>
  </ng-container>
</div>
